import { N600, N800 } from '@atlaskit/theme/colors';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { messages } from '../messages';
import { default as SiteLinkWithAnalytics } from './site-link';

export type SiteListProps = {
  readonly sites: string[];
  readonly product: string;
  readonly domRootId?: string;
};

export function SiteList({ sites, product, domRootId }: SiteListProps) {
  return (
    <Container>
      <Message>
        <FormattedMessage
          {...messages.activeSites}
          values={{ sites: sites.length }}
        />
      </Message>
      <List>
        {sites.map((site) => (
          <ListItem key={`${product}.${site}`}>
            <SiteLinkWithAnalytics
              site={site}
              name={product}
              domRootId={domRootId}
            />
          </ListItem>
        ))}
      </List>
    </Container>
  );
}

export const Message = styled.div`
  font-size: 10px;
  line-height: 16px;
  color: ${N800};
`;

const Container = styled.div`
  margin: 6px 0;
`;

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const ListItem = styled.li`
  font-size: 10px;
  line-height: 16px;
  color: ${N600};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
